module.exports = __webpack_public_path__ + "static/media/banner1.1c92cae5.jpg";